import { Injectable } from '@angular/core';
import { RedsoxChildrenTicketCodesStore } from './redsox-children-ticket-codes.store';
import { RedsoxChildrenTicketCode } from './models/redsox-children-ticket-code.model';

@Injectable({ providedIn: 'root' })
export class RedsoxChildrenTicketCodesService {
  constructor(private redsoxChildrenTicketCodesStore: RedsoxChildrenTicketCodesStore) {}

  /**
   * This will set the store and called in the component
   * if there is no cache on the store. So no change
   * is made to the custom data service.
   * @param data data of custom data set returned.
   */
  setChildrenTicketCodes(data: RedsoxChildrenTicketCode[]) {
    this.redsoxChildrenTicketCodesStore.set(data);
  }
}
